import { Stagger, StaggerItem } from "@/components/motion";
import { SectionHeading } from "@/components/primitives";
import Icon from "@/components/Icon";
import { TRUST } from "@/lib/site";

export default function TrustSecurity() {
  return (
    <section id="trust" className="relative border-t border-border py-24 sm:py-32" data-testid="trust-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Trust & security"
          title="Built to earn your trust from day one."
          subtitle="Security and privacy aren't add-ons — they're part of the foundation."
        />
        <Stagger className="mt-16 grid gap-4 sm:mt-20 sm:grid-cols-2 lg:grid-cols-4">
          {TRUST.map((t) => (
            <StaggerItem key={t.title} className="h-full">
              <div className="flex h-full flex-col gap-4 rounded-2xl border border-border bg-card p-7">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-muted/60 text-brand-teal">
                  <Icon name={t.icon} className="h-5 w-5" />
                </div>
                <h3 className="font-display text-base font-semibold tracking-tight">{t.title}</h3>
                <p className="text-sm leading-relaxed text-muted-foreground">{t.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
